<div class="indicator-container">
    <div
        #valueContainer
        class="value-container"
        [class]="alarmBorderClass"
        [ngStyle]="{ left: valueContainerLeft + 'px' }"
    >
        <span
            class="value-icons"
            [ngClass]="{
                flip: valueChangeDirection == -1,
                hide: valueChangeDirection == 0,
            }"
        >
            <mat-icon
                class="direction-arrow"
                style="opacity: 0.3"
                [class]="alarmTextClass"
                svgIcon="value-pointer"
            >
            </mat-icon>
            <mat-icon
                class="direction-arrow"
                style="opacity: 0.7"
                [class]="alarmTextClass"
                svgIcon="value-pointer"
            >
            </mat-icon>
            <mat-icon
                class="direction-arrow"
                style="opacity: 1"
                [class]="alarmTextClass"
                svgIcon="value-pointer"
            >
            </mat-icon>
        </span>
        <span #valueText class="value-label" [class]="alarmTextClass"></span>
    </div>
    <div class="status" [class]="alarmTextClass">
        {{ statusString | translate }}
    </div>
</div>
